import React from "react";
import "./FormsFilterLine.scss";

const FormsFilterLine = ({ count, onClear }) => (
  <div className="forms-filter-line" role="status">
    <span>
      Showing <strong>{count} Buyer Listing Form {count === 1 ? "request" : "requests"}</strong> waiting for your review
    </span>
    <button type="button" className="forms-filter-line__clear" onClick={onClear}>
      Show all Want-Listings
    </button>
  </div>
);

export default FormsFilterLine;
